import { useState, useEffect } from 'react';

const useCookie = (cookieName) => {
	const [cookieValue, setCookieValue] = useState('');

	const setCookie = (name, value) => {
		const date = new Date();
		date.setTime(date.getTime() + (1 * 24 * 60 * 60 * 1000));
		const expires = '; expires=' + date.toUTCString();
		document.cookie = name + '=' + (value || '') + expires + '; path=/';
	};

	const getCookie = () => {
		const cookies = document.cookie.split(';');
		for (let i = 0; i < cookies.length; i++) {
			const cookie = cookies[i].trim();
			if (cookie.startsWith(`${cookieName}=`)) {
				const [, value] = cookie.split('=');
				const decodedCookie = decodeURIComponent(value);
				try {
					setCookieValue(JSON.parse(decodedCookie));
				} catch (_) {
					setCookieValue(decodedCookie);
				}
				break;
			}
		}
	};

	// Read the cookie initially and whenever the cookieName changes
	useEffect(() => {
		getCookie();
	}, [cookieName]);

	const updateCookie = (value) => {
		setCookieValue(value); // Update the state
		setCookie(cookieName, JSON.stringify(value)); // Set the cookie in the browser
	};

	return [cookieValue, updateCookie];
};

export default useCookie;
